/* Vertrauenszeile im Warenkorb-Drawer: haengt den Block in .cart-drawer__footer,
   haelt die Versandschutz-Position synchron und blendet sie aus der Artikelliste aus. */
(function () {
  if (window.cartTrustInit) return;
  window.cartTrustInit = true;

  var CFG;
  try {
    CFG = JSON.parse(document.getElementById('cart-trust-config').textContent);
  } catch (e) {
    return;
  }
  if (!CFG || !CFG.available || !CFG.variantId) return;

  var OPT_OUT = 'hv:cart-protect:opt-out';
  var busy = false;
  var failed = false;
  var muted = false;
  var addAttempts = 0;
  var timer = null;

  var ICON_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><path d="M12 13v8"/></svg>';
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function optedOut() {
    try { return localStorage.getItem(OPT_OUT) === '1'; } catch (e) { return false; }
  }

  function setOptOut(on) {
    try {
      if (on) localStorage.setItem(OPT_OUT, '1');
      else localStorage.removeItem(OPT_OUT);
    } catch (e) {}
  }

  function post(url, payload) {
    payload.sections = 'cart-drawer,cart-icon-bubble';
    payload.sections_url = window.location.pathname + window.location.search;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function applySections(data) {
    if (!data || !data.sections) return;
    muted = true;
    var cur = document.querySelector('#CartDrawer');
    var drawerHtml = data.sections['cart-drawer'];
    if (drawerHtml && cur) {
      var fresh = parse(drawerHtml).querySelector('#CartDrawer');
      if (fresh) {
        var freshItems = fresh.querySelector('cart-drawer-items');
        var freshFooter = fresh.querySelector('.cart-drawer__footer');
        var curItems = cur.querySelector('cart-drawer-items');
        var curFooter = cur.querySelector('.cart-drawer__footer');
        if (freshItems && freshFooter && curItems && curFooter) {
          curItems.innerHTML = freshItems.innerHTML;
          curFooter.innerHTML = freshFooter.innerHTML;
        } else {
          cur.innerHTML = fresh.innerHTML;
        }
        cur.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      }
    }
    var bubbleHtml = data.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var doc = parse(bubbleHtml);
      var src = doc.querySelector('#shopify-section-cart-icon-bubble') || doc.body;
      bubble.innerHTML = src.innerHTML;
    }
    muted = false;
  }

  function state() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var s = { inCart: false, key: null, regular: 0 };
        (cart.items || []).forEach(function (item) {
          if (item.variant_id === CFG.variantId) {
            s.inCart = true;
            s.key = item.key;
          } else {
            s.regular += item.quantity;
          }
        });
        return s;
      });
  }

  function markup() {
    return '<div class="cart-trust" data-cart-trust data-busy="false">' +
      '<div class="cart-trust__row">' +
        '<span class="cart-trust__icon">' + ICON_BOX + '</span>' +
        '<div class="cart-trust__text"><p class="cart-trust__title">' + esc(CFG.returnLabel) + '</p></div>' +
      '</div>' +
      '<div class="cart-trust__row" data-cart-trust-protect hidden>' +
        '<span class="cart-trust__icon">' + ICON_SHIELD + '</span>' +
        '<div class="cart-trust__text">' +
          '<p class="cart-trust__title">' + esc(CFG.protectTitle) + '</p>' +
          '<p class="cart-trust__sub">' + esc(CFG.protectText) + '</p>' +
        '</div>' +
        '<span class="cart-trust__price">' + esc(CFG.price) + '</span>' +
        '<label class="cart-trust__switch"><input type="checkbox" data-cart-protect-toggle aria-label="' + esc(CFG.protectTitle) + '"><span class="cart-trust__slider"></span></label>' +
      '</div>' +
      '<div class="cart-trust__row">' +
        '<span class="cart-trust__icon">' + ICON_TRUCK + '</span>' +
        '<div class="cart-trust__text"><p class="cart-trust__title">' + esc(CFG.shipTitle) + '</p></div>' +
        '<span class="cart-trust__check">' + ICON_CHECK + '</span>' +
      '</div>' +
    '</div>';
  }

  function hideRows() {
    var rows = document.querySelectorAll('#CartDrawer .cart-item');
    for (var i = 0; i < rows.length; i++) {
      var link = rows[i].querySelector('a[href*="/products/"]');
      if (link && link.getAttribute('href').indexOf('/products/' + CFG.handle) !== -1) {
        rows[i].classList.add('cart-trust-hidden');
      }
    }
  }

  /* Dawn rendert die Warenkorb-Blase inline im Header, nicht ueber die Section.
     Beim normalen Seitenaufruf muss der Versandschutz daher hier herausgerechnet werden. */
  function paintBadge(s) {
    var wrap = document.getElementById('cart-icon-bubble');
    if (!wrap) return;
    var bubble = wrap.querySelector('.cart-count-bubble');
    if (!bubble) return;
    if (s.regular === 0) {
      bubble.classList.add('cart-trust-hidden');
      return;
    }
    bubble.classList.remove('cart-trust-hidden');
    var num = bubble.querySelector('span[aria-hidden]');
    if (num && num.textContent.trim() !== String(s.regular)) num.textContent = s.regular;
    var sr = bubble.querySelector('.visually-hidden');
    if (sr) sr.textContent = s.regular + ' Artikel';
  }

  function ensureBlock() {
    var footer = document.querySelector('#CartDrawer .cart-drawer__footer');
    if (!footer) return null;
    var block = footer.querySelector('[data-cart-trust]');
    if (!block) {
      footer.insertAdjacentHTML('afterbegin', markup());
      block = footer.querySelector('[data-cart-trust]');
    }
    return block;
  }

  function setBusy(on) {
    busy = on;
    var block = document.querySelector('#CartDrawer [data-cart-trust]');
    if (block) block.setAttribute('data-busy', on ? 'true' : 'false');
  }

  function paint(s) {
    paintBadge(s);
    var block = ensureBlock();
    if (!block) return;
    var row = block.querySelector('[data-cart-trust-protect]');
    var box = block.querySelector('[data-cart-protect-toggle]');
    if (row) row.hidden = s.regular === 0;
    if (box) box.checked = s.inCart;
  }

  function addProtection() {
    return post('/cart/add.js', { items: [{ id: CFG.variantId, quantity: 1 }] });
  }

  function removeProtection(key) {
    return post('/cart/change.js', { id: key, quantity: 0 });
  }

  function settle() {
    setBusy(false);
    hideRows();
    state().then(paint).catch(function () {});
  }

  function sync() {
    if (busy || failed) return;
    state().then(function (s) {
      if (s.inCart) addAttempts = 0;
      if (s.regular === 0 && s.inCart) {
        setBusy(true);
        return removeProtection(s.key)
          .then(applySections)
          .catch(function () { failed = true; })
          .then(settle);
      }
      if (s.regular > 0 && !s.inCart && CFG.defaultOn && !optedOut() && addAttempts < 3) {
        addAttempts++;
        setBusy(true);
        return addProtection()
          .then(applySections)
          .catch(function () { failed = true; })
          .then(settle);
      }
      hideRows();
      paint(s);
    }).catch(function () {});
  }

  function schedule() {
    if (muted) return;
    clearTimeout(timer);
    timer = setTimeout(sync, 180);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.hasAttribute || !target.hasAttribute('data-cart-protect-toggle')) return;
    var want = target.checked;
    setOptOut(!want);
    addAttempts = 0;
    setBusy(true);
    var job = want
      ? addProtection()
      : state().then(function (s) { return s.key ? removeProtection(s.key) : null; });
    job.then(applySections).catch(function () {}).then(settle);
  });

  function boot() {
    state().then(paintBadge).catch(function () {});
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return;
    new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
